const indexItems = [
  {
    title: '电影大全',
    desc: '动作·喜剧·科幻·爱情·恐怖全类型覆盖',
    icon: 'ri-film-line',
    img: 'https://readdy.ai/api/search-image?query=Movie%20collection%20wall%20with%20diverse%20film%20posters%20in%20warm%20cinema%20lighting%2C%20artistic%20composition%20of%20movie%20genres%2C%20golden%20age%20of%20cinema%20aesthetic%2C%20rich%20color%20palette%2C%20elegant%20entertainment%20wall%20display&width=600&height=350&seq=index-01-movies&orientation=landscape',
    alt: '91影视看片下载 - 电影大全',
  },
  {
    title: '电视剧场',
    desc: '国产·韩剧·美剧·日剧·泰剧专题分类',
    icon: 'ri-tv-2-line',
    img: 'https://readdy.ai/api/search-image?query=TV%20drama%20series%20collection%20with%20various%20show%20scenes%2C%20warm%20living%20room%20viewing%20atmosphere%2C%20cozy%20entertainment%20aesthetic%2C%20golden%20ambient%20lighting%2C%20modern%20home%20theater%20concept&width=600&height=350&seq=index-02-dramas&orientation=landscape',
    alt: '91影视看片下载 - 电视剧场',
  },
  {
    title: '综艺娱乐',
    desc: '热门综艺·真人秀·脱口秀一网打尽',
    icon: 'ri-emotion-laugh-line',
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20with%20colorful%20lighting%20and%20energetic%20atmosphere%2C%20entertainment%20studio%20set%2C%20bright%20warm%20spotlights%2C%20cheerful%20TV%20production%20aesthetic%2C%20vibrant%20game%20show%20concept&width=600&height=350&seq=index-03-variety&orientation=landscape',
    alt: '91影视看片下载 - 综艺娱乐',
  },
  {
    title: '动漫世界',
    desc: '日漫·国漫·剧场版高清合集',
    icon: 'ri-ghost-smile-line',
    img: 'https://readdy.ai/api/search-image?query=Anime%20art%20collection%20with%20colorful%20illustration%20style%2C%20Japanese%20animation%20aesthetic%2C%20warm%20golden%20and%20vibrant%20color%20palette%2C%20artistic%20manga%20and%20anime%20visual%20display%2C%20creative%20entertainment%20concept&width=600&height=350&seq=index-04-anime&orientation=landscape',
    alt: '91影视看片下载 - 动漫世界',
  },
  {
    title: '纪录片库',
    desc: '自然·历史·科技·人文经典纪录',
    icon: 'ri-earth-line',
    img: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20scene%20with%20wildlife%20and%20landscapes%2C%20warm%20natural%20lighting%2C%20cinematic%20planet%20earth%20style%2C%20golden%20hour%20photography%2C%20educational%20and%20beautiful%20visual%20composition&width=600&height=350&seq=index-05-documentary&orientation=landscape',
    alt: '91影视看片下载 - 纪录片库',
  },
  {
    title: '天美麻花专区',
    desc: '天美麻花星空影视独家内容入口',
    icon: 'ri-star-smile-line',
    img: 'https://readdy.ai/api/search-image?query=Exclusive%20premium%20cinema%20lounge%20with%20golden%20starry%20sky%20and%20luxurious%20seating%2C%20VIP%20theater%20experience%2C%20elegant%20dark%20and%20gold%20color%20scheme%2C%20sophisticated%20entertainment%20space%2C%20warm%20ambient%20lighting&width=600&height=350&seq=index-06-tianmei&orientation=landscape',
    alt: '天美麻花星空影视免费观看 - 天美麻花专区',
  },
  {
    title: '最新更新',
    desc: '今日更新列表，第一时间追新剧',
    icon: 'ri-timer-flash-line',
    img: 'https://readdy.ai/api/search-image?query=Modern%20digital%20media%20update%20feed%20with%20glowing%20screens%2C%20fresh%20content%20notification%20concept%2C%20warm%20tech%20aesthetic%2C%20golden%20and%20amber%20notification%20lights%2C%20dynamic%20streaming%20platform%20visual&width=600&height=350&seq=index-07-updates&orientation=landscape',
    alt: '91影视看片下载 - 最新更新',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            影视索引
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            全站影视内容导航
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            七大内容板块，快速定位想看的内容类型，找片从此不迷路
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#"
              className={`group relative overflow-hidden rounded-xl bg-background-50 transition-all duration-300 cursor-pointer ${
                idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              } ${idx === 5 ? 'lg:col-span-2' : ''}`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'aspect-[16/9] lg:aspect-auto lg:h-full' : 'aspect-[16/10]'}`}>
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                    (el.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/20 to-transparent"></div>
              </div>
              <div className={`absolute bottom-0 left-0 right-0 p-4 md:p-5 ${idx === 0 ? 'lg:p-6' : ''}`}>
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-7 h-7 rounded-lg bg-accent-500 flex items-center justify-center">
                    <i className={`${item.icon} text-background-50 text-sm w-4 h-4 flex items-center justify-center`}></i>
                  </div>
                  <h3 className={`font-heading font-bold text-background-50 group-hover:text-accent-300 transition-colors ${idx === 0 ? 'text-xl md:text-2xl' : 'text-base md:text-lg'}`}>
                    {item.title}
                  </h3>
                </div>
                <p className="text-white/65 text-xs md:text-sm">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}